import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { shareReplay, catchError, switchMap, tap } from 'rxjs/operators';

import { WindowRefService } from '../../../../services/window-ref.service';
import { SessionStorageService } from '../../../../services/web-storage/session-storage.service';

import { ContentVersioningService } from '../content-versioning/content-versioning.service';

@Injectable({
  providedIn: 'root'
})
export class AppMessagesService {
  protected dataStoreKey = 'maAppMessages';

  private messagesObservable: Observable<any>;

  constructor(
    private http: HttpClient,
    private windowRefService: WindowRefService,
    private contentVersioningService: ContentVersioningService,
    private sessionStorageService: SessionStorageService
  ) {}

  /**
   * @returns app messages
   */
  getAppMessages(): Observable<any> {
    const storageValue = this.sessionStorageService.getItem(this.dataStoreKey, true);

    if (storageValue) {
      return of(storageValue);
    }

    if (this.messagesObservable) {
      return this.messagesObservable;
    }

    const url = this.getApiUrl();

    this.messagesObservable = this.contentVersioningService.getVersion('app-messages').pipe(
      switchMap(version => {
        return this.http.get(`${url}?v=${version}`);
      }),
      tap((appMessages: any) => {
        this.sessionStorageService.setItem(this.dataStoreKey, appMessages, true);
      }),
      catchError((error: any) => {
        return of(null);
      }),
      shareReplay(1)
    );

    return this.messagesObservable;
  }

  private getApiUrl(): string {
    return this.windowRefService.nativeWindow.environment.CONTENT_CDN_URL +
           '/mypru/v2/node/app-messages.json';
  }
}
